import Invoice from "../../common/models/Invoice";
import PdfPageWithText from "./PdfPageWithText";
import PdfProcessedPage from "./PdfProcessedPage";

export default abstract class Driver {
    constructor() {

    }

    abstract check(pdf_text_contents: string[]): boolean;
    abstract parse_pages(page: PdfPageWithText[]): PdfProcessedPage[];
    abstract stamp_invoices(invoices: Invoice[]): Promise<Invoice[]>;
    
    parse_money_string(money_str: string | null | undefined): number | null {
        if (money_str === null || typeof money_str === "undefined") {
            return null
        }

        console.log("money_str", money_str)
        // Remove any currency symbols and spaces
        let cleaned = money_str.replace(/[^0-9.,-]/g, '').trim();
    
        // If both comma and dot exist, figure out which is the decimal
        const comma_count = (cleaned.match(/,/g) || []).length;
        const dot_count = (cleaned.match(/\./g) || []).length;
    
        if (comma_count > 0 && dot_count > 0) {
            // Determine decimal and thousand separators by last occurrence
            if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
                // Comma is decimal
                cleaned = cleaned.replace(/\./g, '').replace(',', '.');
            } else {
                // Dot is decimal
                cleaned = cleaned.replace(/,/g, '');
            }
        } else if (comma_count > 0 && dot_count === 0) {
            // Could be European format like "2.345,67"
            if (cleaned.indexOf(',') === cleaned.length - 3) {
                cleaned = cleaned.replace(/\./g, '').replace(',', '.');
            } else {
                cleaned = cleaned.replace(/,/g, '');
            }
        } else {
            // Just remove any commas
            cleaned = cleaned.replace(/,/g, '');
        }
    
        const number = parseFloat(cleaned);
    
        return isNaN(number) ? null : number;
    }
}